import style from './index.module.scss';

function SubFooter({ menu }) {
    return (
        <div className={style.background}>
            <ul className={style.content}>
                <p>{`@${new Date().getFullYear()} Fert Recyclage / Tous droits réservés`}</p>
                {menu &&
                    Object.values(menu).map((menuItem, id) => {
                        return (
                            <li key={id}>
                                <a href={menuItem.url} className={style.link}>
                                    {menuItem.title}
                                </a>
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
}

export default SubFooter;
